import React from 'react';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import DownloadingIcon from '@mui/icons-material/Downloading';
import RenderTextfieldHeader from 'pages/renderTextFieldHeader';
import { renderSelectHeader } from "../DashboardHelpers";
import OcplcMenuList from './ocplcMenulist';
import moment from 'moment';

const columnTypes = {
    kmatId: {
        type: 'text',
        name: 'kmatId',
        matchFields: ['kmatId'],
    },
    status: {
        type: 'text',
        name: 'status',
        matchFields: ['status']
    },
    productLineName: {
        type: 'text',
        name: 'productLineName',
        matchFields: ['productLineName'],
    },
    productName: {
        type: 'text',
        name: 'productName',
        matchFields: ['manufacturingName'],
    },
    author: {
        type: 'text',
        name: 'author',
        matchFields: ['author'],
    },
};

const DefineColumns = ({ filters, handleChange, ocplcProductLines, statuses, userRole, userEmail }) => {


    return [
        {
            headerName: 'KMAT ID',
            field: 'kmatId',
            headerClassName: 'dashboard-data-grid-headers',
            flex: 0.5,
            sortable: false,
            renderCell: (params) => (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Typography variant='subtitle2'>{params.row.kmatId}</Typography>
                    {params.row.toadLogicalLock === 'Y' && <Tooltip title="Bulk upload activity is in progress for this Record."><DownloadingIcon htmlColor='#0278AB' sx={{ marginLeft: '5px', fontSize: '16px' }} /></Tooltip>}
                </div>
            ),
            renderHeader: () => <RenderTextfieldHeader colData={columnTypes?.kmatId} label={"KMAT ID"} filters={filters} handleChange={handleChange} />,
        },
        {
            headerName: 'Product Name',
            field: 'productName',
            headerClassName: 'dashboard-data-grid-headers',
            headerAlign: 'left',
            flex: 0.5,
            sortable: false,
            renderCell: (params) => <Typography variant='subtitle2'>{params.row.manufacturingName}</Typography>,
            renderHeader: () => <RenderTextfieldHeader colData={columnTypes?.productName} label={"Product Name"} filters={filters} handleChange={handleChange} />,
        },
        {
            headerName: 'Status',
            field: 'status',
            headerClassName: 'dashboard-data-grid-headers',
            headerAlign: 'left',
            flex: 0.5,
            sortable: false,
            renderCell: (params) => {
                const status = params.row.status || '';
                const importsCount = params.row.imports ? Object.keys(params.row.imports).length : 0;
                return (
                    <div className='row-status'>
                        <Typography variant='subtitle2'>
                            {status.charAt(0).toUpperCase() + status.slice(1)}
                        </Typography>
                        {importsCount > 0 && <div className='imports-count'>{importsCount}</div>}
                    </div>
                );
            },
            renderHeader: () => renderSelectHeader(columnTypes?.status, filters, 'Status', handleChange, statuses),
        },
        {
            headerName: 'Product Line',
            field: 'productLine',
            headerClassName: 'dashboard-data-grid-headers',
            flex: 0.6,
            sortable: false,
            renderHeader: () => renderSelectHeader(columnTypes?.productLineName, filters, 'Product Line', handleChange, ocplcProductLines),
            renderCell: (params) => (
                <div className='effective-date-data'>
                    <Typography variant='subtitle2'>{params.row.productLineName}</Typography>
                </div>
            ),
        },
        {
            headerName: 'Author',
            field: 'author',
            headerClassName: 'dashboard-data-grid-headers',
            flex: 0.7,
            sortable: false,
            renderCell: (params) => {
                return (
                    <div className='effective-date-data'>
                        <Typography variant='subtitle2'>{params.row.author}</Typography>
                        {params.row.status !== 'New' && moment(params.row.lastModifiedTS).isValid() &&
                            <Typography className='file-name effective-date-data' sx={{ fontSize: "12px" }}>
                                {moment(params.row.lastModifiedTS).utc().format('LLLL')}{' - '}{moment(params.row.lastModifiedTS).utc().fromNow()}
                            </Typography>
                        }
                    </div>)
            },
            renderHeader: () => <RenderTextfieldHeader colData={columnTypes?.author} label={"Author"} filters={filters} handleChange={handleChange} />,
        },
        {
            headerName: '',
            field: 'actions',
            headerClassName: 'dashboard-data-grid-headers',
            width: 200,
            sortable: false,
            renderCell: (params) => (
                <div className="action-button-class">
                    <OcplcMenuList
                        row={params.row}
                        loginUserEmailId={userEmail}
                        userRole={userRole}
                    />
                </div>
            ),
        },
    ];
};

export default DefineColumns;